import React, { ReactNode } from "react";

import Autocomplete from "../Autocomplete";

interface OptionType {
  value: any;
  label: string;
}

interface AutocompleteFormGroupProps {
  customerId: string | number;
  role: string;
  label?: string;
  onChange: (value: OptionType | OptionType[] | null) => void;
  value?: OptionType | OptionType[] | null;
  autocompleteUrl: string;
  onCreate?: (() => void) | null;
  createLabel?: string;
  onEdit?: (() => void) | null;
  editLabel?: string;
  validate?: boolean;
  valid?: boolean;
  helpText?: ReactNode | false;
  required?: boolean;
  showAll?: boolean;
  isClearable?: boolean;
  error?: string | null;
  id?: string;
  [key: string]: any; // for extraProps
}

const AutocompleteFormGroup: React.FC<AutocompleteFormGroupProps> = ({
  customerId,
  role,
  label,
  onChange,
  value,
  autocompleteUrl,
  onCreate = null,
  createLabel = "",
  onEdit = null,
  editLabel = "",
  validate = false,
  valid = true,
  helpText = false,
  required = false,
  showAll = false,
  isClearable = true,
  error = null,
  id = undefined,
  ...extraProps
}) => {
  const hasError = (required && validate && !value) || error;
  const styles = hasError ? { borderColor: "red" } : {};

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={id}>
          {label}
          {required && "*"}
        </label>
      )}
      <div className="d-flex">
        <div className="flex-grow-1">
          <Autocomplete
            url={autocompleteUrl}
            customerId={customerId}
            role={role}
            onChange={onChange}
            value={value || undefined}
            isClearable={isClearable}
            valid={valid}
            validate={validate}
            showAll={showAll}
            styles={{
              control: (base: any) => ({ ...base, ...styles }),
            }}
            inputId={id}
            {...extraProps}
          />
        </div>
        {(onCreate || onEdit) && (
          <div className="btn-group btn-group-sm ml-2 mt-2">
            {onEdit && value && (
              <button
                type="button"
                className="btn text-primary"
                tabIndex={-1}
                onClick={() => {
                  onEdit();
                }}
              >
                <i className="fas fa-edit" title={editLabel} />
                <span className="sr-only">{editLabel}</span>
              </button>
            )}
            {onCreate && (
              <button
                className="btn text-primary"
                type="button"
                tabIndex={-1}
                onClick={() => {
                  onCreate();
                }}
              >
                <i className="fas fa-plus" title={createLabel} />
                <span className="sr-only">{createLabel}</span>
              </button>
            )}
          </div>
        )}
      </div>
      {helpText && <small className="form-text text-muated">{helpText}</small>}
      {error && <small className="form-text text-danger">{error}</small>}
    </div>
  );
};

export default AutocompleteFormGroup;
